type LogLevel = 'log' | 'warn' | 'error';

const debugLog = (level: LogLevel, ...args: unknown[]) => {
  console[level](...args);
};

export default debugLog;
